export default "__VITE_ASSET__f5b63819__"